var modules_1be33e45 = {"container":"StoresBanner_module_container__fe323961","firstColumn":"StoresBanner_module_firstColumn__fe323961","secondColumn":"StoresBanner_module_secondColumn__fe323961"};
import "../../../assets/CePSgSpW.css";

export { modules_1be33e45 as default };
//# sourceMappingURL=StoresBanner.module.less.js.map
